import { render, staticRenderFns } from "./Template99.vue?vue&type=template&id=710267a0&scoped=true&"
import script from "./Template99.vue?vue&type=script&lang=js&"
export * from "./Template99.vue?vue&type=script&lang=js&"
import style0 from "./Template99.vue?vue&type=style&index=0&id=710267a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710267a0",
  null
  
)

export default component.exports